import {API_DOMAIN} from "../config"
import {fetchData} from "../util"


export const fetchClubCleanTableRecord = async (params) => {
    let queryString =new URLSearchParams(params).toString()
    let endpoint = `${API_DOMAIN}/Home/EmployeeApi/GetCleanTableRecord?${queryString}`

    return fetchData(endpoint)
}

export const fetchEmployeeList = async (params) => {
    let queryString =new URLSearchParams(params).toString()
    let endpoint = `${API_DOMAIN}/Home/EmployeeApi/GetEmployeeList?${queryString}`
    return fetchData(endpoint)
}

export const fetchTableList = async (params) => {
    let queryString =new URLSearchParams(params).toString()
    let endpoint = `${API_DOMAIN}/Home/EmployeeApi/GetTableList?${queryString}`
    return fetchData(endpoint)
}


// WEBPACK FOOTER //
// ./src/api/clubCleanTableRecord.js